import React, { useState, useEffect, useContext } from "react";
import { useQuery } from "@apollo/react-hooks";
import { useParams } from "react-router-dom";
import { Summary } from "../../../../../components/admin/batches/show/summary";
import { MainMenu } from "../../../../../components/admin/shared";
import { Section, SidebarLayout } from "../../../../../components/shared";
import { BatchDetailsContextProvider } from "../../../../../contexts/admin/batches/batch-details";
import {
  default as Navbar
} from "../../../../../components/admin/batches/show/navbar";
import { client } from "../../../../../../graphql";
import { admin } from "../../../../../graphql/admin";
import { Head } from "../../../../../components/admin/batches/show/tasks/head";
import { CreateTaskModalProvider } from "../../../../../contexts/shared/create-task-modal";
import { FilterControls } from "../../../../../components/admin/batches/show/tasks/filter-controls";
import {
  default as TaskTable
} from "../../../../../components/shared/task-table";
import { shared } from "../../../../../graphql/shared";
import { MenuContext } from "../../../../../contexts/shared/menu";
import { TaskDetailsModalContextProvider } from "../../../../../contexts/shared/task-details-modal/provider";


export function TasksIndex() {
  const { id } = useParams();
  const { setMenuState } = useContext(MenuContext);
  const [ filters, setSelectedFilters ] = useState({
    selectedOde: undefined,
    selectedState: "all",
    inputSearch: ""
  });

  const { data, loading, error, refetch } = useQuery(
    shared.queries.getTasks,
    {
      fetchPolicy: "network-only",
      variables: {
        where: {
          batch: {id: id},
          ode: {id: filters.selectedOde}
        }
      },
      client
    }
  );

  const {
    loading: batchLoading,
    error: batchError,
    data: batchData
  } = useQuery(
    admin.queries.getBatchById,
    {
      fetchPolicy: "network-only",
      variables: { id: id },
      client
    }
  );

  useEffect(() => {
    refetch();
  },[filters.selectedOde]);

  useEffect(() => {
    setMenuState({
      openKeys: ["programs"],
      selectedKeys: ["batches"]
    });
  }, []);

  const handleOdeSelect = odeId => {
    setSelectedFilters(state => ({
      ...state,
      selectedOde: odeId
    }));
  };

  const handleSelectorChange = value => {
    setSelectedFilters(state => ({
      ...state,
      selectedState: value
    }));
  };

  const handleInputSearch = value => {
    setSelectedFilters(state => ({
      ...state,
      inputSearch: value
    }));
  };

  const handleSearchChange = e => {
    if(e?.target?.value === ""){
      setSelectedFilters(state => ({
        ...state,
        inputSearch: ""
      }));
    }
  };

  return (
    <BatchDetailsContextProvider>
      <TaskDetailsModalContextProvider>
        <CreateTaskModalProvider selectedOde={filters.selectedOde}>
          <SidebarLayout menu={<MainMenu />}>
            <Summary
              isLoading={batchLoading}
              error={batchError}
              data={batchData} />
            <Navbar selectedKeys={["tasks"]} />
            <Section
              title="Tareas"
              spaced
              extra={<FilterControls
                hideFilters={{batchesSelect: true}}
                handleOdeSelect={handleOdeSelect}
                handleSelectorChange={handleSelectorChange}
                handleInputSearch={handleInputSearch}
                resetTableContent={handleSearchChange} />}>
              <Head />
              <TaskTable
                data={data}
                error={error}
                isLoading={loading}
                selectedState={filters.selectedState}
                inputSearch={filters.inputSearch} />
            </Section>
          </SidebarLayout>
        </CreateTaskModalProvider>
      </TaskDetailsModalContextProvider>
    </BatchDetailsContextProvider>
  );
}